import { useUpdateEventTodos } from './queries';

export * from './components/TodosWidget';

export const queries = {
  hooks: {
    useUpdateEventTodos,
  },
};
